import React, { useState, useEffect, useRef, useMemo } from "react";
import "./App.css";
import "./AlphabetNavigation.css";
import "react-tooltip/dist/react-tooltip.css";
import { initializeApp } from "firebase/app";
import { getFirestore, doc, setDoc, getDoc } from "firebase/firestore";
import { FaHeart, FaFolderPlus, FaEdit, FaTrash } from "react-icons/fa";
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useInView } from 'react-intersection-observer';


// const firebaseConfig = {
//   apiKey: "AIzaSyDwEvaMA5eRQslwtgi40_F-w7xTmQGu2N8",
//   authDomain: "galeria-8c52a.firebaseapp.com",
//   projectId: "galeria-8c52a",
//   storageBucket: "galeria-8c52a.firebasestorage.app",
//   messagingSenderId: "477736393698",
//   appId: "1:477736393698:web:1119dad487d6245d9cf7bb",
//   measurementId: "G-NS347BV1W9"
// };

const firebaseConfig = {
  apiKey: "AIzaSyDz7c64XEUK3FiigM6dajZpOCbnDKg9UIk",
  authDomain: "galeria-geral-747a8.firebaseapp.com",
  projectId: "galeria-geral-747a8",
  storageBucket: "galeria-geral-747a8.firebasestorage.app",
  messagingSenderId: "927170740553",
  appId: "1:927170740553:web:184995fde24a720be45a98",
  measurementId: "G-RRM14E3Y3W"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

const AlphabetNavigation = ({ onLetterClick, activeLetters }) => {
  const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

  return (
    <div className="alphabet-navigation">
      {alphabet.map((letter) => (
        <button
          key={letter}
          onClick={() => onLetterClick(letter)}
          className={activeLetters.includes(letter) ? "active" : ""}
          disabled={!activeLetters.includes(letter)}
        >
          {letter}
        </button>
      ))}
    </div>
  );
};

const LazyImage = ({ src, alt, onClick, onFavoriteToggle, isFavorite, formatImageName, category }) => {
  const { ref, inView } = useInView({
    threshold: 0.1,
  });

  return (
    <div ref={ref} className="image-container">
      {inView ? (
        <>
          <button
            className="favorite-button"
            onClick={onFavoriteToggle} // Chama a função para alternar favorito
          >
            <FaHeart color={isFavorite ? "red" : "gray"} />
          </button>
          {isFavorite && category && (
            <div className="category-tag">{category}</div>
          )}
          <img
            src={src}
            alt={alt}
            className="image"
            loading="lazy"
            onClick={onClick} // Adiciona o manipulador de clique aqui
          />
          <p className="image-name">{formatImageName(alt)}</p> {/* Exibe o nome da imagem */}
        </>
      ) : (
        <div className="image-placeholder">Carregando...</div>
      )}
    </div>
  );
};

const App = () => {
  const [images, setImages] = useState([]);
  const [displayedImages, setDisplayedImages] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loadIndex, setLoadIndex] = useState(55);
  const [selectedImage, setSelectedImage] = useState(null);
  const [favorites, setFavorites] = useState([]);
  // Nova estrutura para favoritos categorizados
  const [categorizedFavorites, setCategorizedFavorites] = useState({});
  const [filterOption, setFilterOption] = useState("todos");
  const [selectedCategory, setSelectedCategory] = useState("todas");
  const [user, setUser] = useState(null);
  const [imagesByLetter, setImagesByLetter] = useState({});
  const [activeLetters, setActiveLetters] = useState([]);
  const [categories, setCategories] = useState(["Outros"]);
  const [showCategoryModal, setShowCategoryModal] = useState(false);
  const [newCategoryName, setNewCategoryName] = useState("");
  const [editingCategory, setEditingCategory] = useState(null);
  const [showAssignCategoryModal, setShowAssignCategoryModal] = useState(false);
  const [imageToAssignCategory, setImageToAssignCategory] = useState(null);
  const sectionRefs = useRef({});

  const formatImageName = (filename, truncate = true) => {
    let nameWithoutExtension = filename.replace(/\.[^/.]+$/, "");
    let nameWithoutLastUnderscore = nameWithoutExtension.replace(/_(\d+)$/, "");
    let nameWithSpaces = nameWithoutLastUnderscore.replace(/_/g, " ");
    return truncate && nameWithSpaces.length > 18 ? nameWithSpaces.substring(0, 18) : nameWithSpaces;
  };

  const handleLogin = async () => {
    try {
      await signInWithPopup(auth, provider);
    } catch (error) {
      console.error("Erro ao fazer login:", error);
    }
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      window.location.reload(); // Recarrega a página após o logout
    } catch (error) {
      console.error("Erro ao fazer logout:", error);
    }
  };

  // Função para organizar as imagens por letra inicial
  useEffect(() => {
    if (images.length > 0) {
      const byLetter = {};
      const letters = new Set();

      images.forEach(img => {
        const formattedName = formatImageName(img);
        const firstLetter = formattedName.charAt(0).toUpperCase();

        if (!byLetter[firstLetter]) {
          byLetter[firstLetter] = [];
        }

        byLetter[firstLetter].push(img);
        letters.add(firstLetter);
      });

      setImagesByLetter(byLetter);
      setActiveLetters(Array.from(letters).sort());
    }
  }, [images]);

  // Função para rolar até a seção da letra clicada
  const scrollToLetter = (letter) => {
    if (sectionRefs.current[letter]) {
      sectionRefs.current[letter].scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  // Filtra as imagens com base no termo de busca
  const filteredImages = useMemo(() => {
    if (!searchTerm.trim()) return images;
    return images.filter((img) =>
      formatImageName(img, false).toLowerCase().includes(searchTerm.toLowerCase().trim())
    );
  }, [images, searchTerm]);
  
  // Função para obter a categoria de uma imagem
  const getImageCategory = (img) => {
    for (const [category, imgs] of Object.entries(categorizedFavorites)) {
      if (imgs.includes(img)) {
        return category;
      }
    }
    return "Outros";
  };

  const renderFilteredImages = () => {
    // Para favoritos com todas as categorias, retornamos diretamente sem a div "grid"
    if (filterOption === "favoritos" && selectedCategory === "todas") {
      return (
        <div className="filtered-images-by-category">
          {categories.map(category => {
            const imagesInCategory = categorizedFavorites[category] || [];
            if (imagesInCategory.length === 0) return null;
            
            return (
              <div key={category} className="category-section">
                <div className="section-header">
                  {category} ({imagesInCategory.length})
                </div>
                <div className="category-images-grid">
                  {imagesInCategory.map(img => {
                    return (
                      <LazyImage
                        key={img}
                        src={`/imagens-op/${img}`}
                        alt={img}
                        onClick={() => openModal(img)}
                        onFavoriteToggle={() => toggleFavorite(img)}
                        isFavorite={true}
                        formatImageName={formatImageName}
                        category={category}
                      />
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      );
    }

    // Para outros casos, retornamos a grid normal
    let filtered = [];
    
    if (filterOption === "favoritos") {
      // Mostrar apenas favoritos da categoria selecionada
      filtered = categorizedFavorites[selectedCategory] || [];
    } else if (filterOption === "naoFavoritos") {
      filtered = images.filter(img => !favorites.includes(img));
    } else {
      filtered = filteredImages; // Usa as imagens filtradas pelo termo de busca
    }

    return (
      <div className="filtered-images-grid">
        {filtered.map((img, index) => {
          const isFavorite = favorites.includes(img);
          const category = isFavorite ? getImageCategory(img) : null;
          
          return (
            <LazyImage
              key={img}
              src={`/imagens-op/${img}`}
              alt={img}
              onClick={() => openModal(img)}
              onFavoriteToggle={() => toggleFavorite(img)}
              isFavorite={isFavorite}
              formatImageName={formatImageName}
              category={category}
            />
          );
        })}
      </div>
    );
  };

  const loadMoreImagesForLetter = (letter) => {
    const currentLoadIndex = loadIndex; // Use o índice de carregamento atual
    const imagesForLetter = imagesByLetter[letter] || [];
    const nextIndex = currentLoadIndex + 100; // Carregar mais 100 imagens desta letra

    setLoadIndex(nextIndex); // Atualiza o índice de carregamento

    const imagesToShow = imagesForLetter.slice(0, nextIndex);
    setDisplayedImages(imagesToShow); // Atualiza as imagens exibidas
  };

  const renderImagesByLetter = () => {
    // Se houver um termo de busca, mostramos as imagens filtradas em vez de por letra
    if (searchTerm.trim()) {
      return (
        <div className="search-results">
          <div className="section-header">
            Resultados da busca ({filteredImages.length})
          </div>
          {filteredImages.map((img, index) => {
            const isFavorite = favorites.includes(img);
            const category = isFavorite ? getImageCategory(img) : null;
            
            return (
              <LazyImage
                key={img}
                src={`/imagens-op/${img}`}
                alt={img}
                onClick={() => openModal(img)}
                onFavoriteToggle={() => toggleFavorite(img)}
                isFavorite={isFavorite}
                formatImageName={formatImageName}
                category={category}
              />
            );
          })}
        </div>
      );
    }

    // Se não houver termo de busca, mostramos por letra como antes
    return Object.keys(imagesByLetter).sort().map(letter => {
      const imagesForLetter = imagesByLetter[letter] || [];
      const imagesToShow = imagesForLetter.slice(0, loadIndex);

      return (
        <React.Fragment key={letter}>
          <div
            className="section-header"
            ref={el => sectionRefs.current[letter] = el}
          >
            {letter} ({imagesForLetter.length})
          </div>
          {imagesToShow.map((img, index) => {
            const isFavorite = favorites.includes(img);
            const category = isFavorite ? getImageCategory(img) : null;

            return (
              <LazyImage
                key={img}
                src={`/imagens-op/${img}`}
                alt={img}
                onClick={() => openModal(img)}
                onFavoriteToggle={() => toggleFavorite(img)}
                isFavorite={isFavorite}
                formatImageName={formatImageName}
                category={category}
              />
            );
          })}

          {imagesForLetter.length > loadIndex && (
            <button
              onClick={() => loadMoreImagesForLetter(letter)}
              className="load-more-letter"
            >
              Carregar mais imagens com {letter}
            </button>
          )}
        </React.Fragment>
      );
    });
  };

  // Função para alterar a exibição com base no `select`
  const handleFilterChange = (option) => {
    setFilterOption(option);
  };

  // Função para alterar a categoria selecionada
  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
  };

  const imagesToDisplay = useMemo(() => {
    switch (filterOption) {
      case "favoritos":
        if (selectedCategory === "todas") {
          return favorites;
        } else {
          return categorizedFavorites[selectedCategory] || [];
        }
      case "naoFavoritos":
        return images.filter((img) => !favorites.includes(img));
      default:
        return searchTerm.trim() ? filteredImages : displayedImages;
    }
  }, [filterOption, selectedCategory, displayedImages, favorites, categorizedFavorites, images, filteredImages, searchTerm]);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      setUser(currentUser);

      if (currentUser) {
        loadUserFavorites(currentUser.uid);
        loadUserCategories(currentUser.uid);
      } else {
        setFavorites([]);
        setCategorizedFavorites({});
        setCategories(["Outros"]);
      }
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    fetch("/imagens-op.json")
      .then((response) => response.json())
      .then((data) => {
        setImages(data);
        setDisplayedImages(data.slice(0, 55)); // Exibir as primeiras 55 imagens
      })
      .catch((error) => console.error("Erro ao buscar imagens:", error));
  }, []);

  const loadUserFavorites = async (userId) => {
    try {
      const userFavoritesRef = doc(db, "userFavorites", userId);
      const userFavoritesSnap = await getDoc(userFavoritesRef);

      if (userFavoritesSnap.exists()) {
        const userData = userFavoritesSnap.data();
        const userFavorites = userData.favorites || [];
        const userCategorizedFavorites = userData.categorizedFavorites || {};
        
        // Garantir que todos os favoritos estejam em categorias
        const allCategorizedImages = Object.values(userCategorizedFavorites).flat();
        const uncategorizedImages = userFavorites.filter(img => !allCategorizedImages.includes(img));
        
        // Adicionar imagens não categorizadas à categoria "Outros"
        if (uncategorizedImages.length > 0) {
          const updatedCategorizedFavorites = {
            ...userCategorizedFavorites,
            "Outros": [...(userCategorizedFavorites["Outros"] || []), ...uncategorizedImages]
          };
          
          // Atualizar no Firestore
          await setDoc(userFavoritesRef, {
            favorites: userFavorites,
            categorizedFavorites: updatedCategorizedFavorites,
            categories: userData.categories || ["Outros"]
          });
          
          setCategorizedFavorites(updatedCategorizedFavorites);
        } else {
          setCategorizedFavorites(userCategorizedFavorites);
        }
        
        setFavorites(userFavorites);
      } else {
        setFavorites([]);
        setCategorizedFavorites({ "Outros": [] });
      }
    } catch (error) {
      console.error("Erro ao carregar favoritos:", error);
      setFavorites([]);
      setCategorizedFavorites({ "Outros": [] });
    }
  };

  const loadUserCategories = async (userId) => {
    try {
      const userFavoritesRef = doc(db, "userFavorites", userId);
      const userFavoritesSnap = await getDoc(userFavoritesRef);

      if (userFavoritesSnap.exists()) {
        const userData = userFavoritesSnap.data();
        const userCategories = userData.categories || ["Outros"];
        setCategories(userCategories);
      } else {
        setCategories(["Outros"]);
      }
    } catch (error) {
      console.error("Erro ao carregar categorias:", error);
      setCategories(["Outros"]);
    }
  };

  // Função para adicionar uma nova categoria
  const addCategory = async () => {
    if (!user) {
      toast.warn("Você precisa estar logado para gerenciar categorias.", {
        position: "top-right",
        autoClose: 1500,
        onClose: () => handleLogin(),
      });
      return;
    }

    if (!newCategoryName.trim()) {
      toast.error("O nome da categoria não pode estar vazio.");
      return;
    }

    if (categories.includes(newCategoryName.trim())) {
      toast.error("Esta categoria já existe.");
      return;
    }

    const updatedCategories = [...categories, newCategoryName.trim()];
    
    try {
      const userFavoritesRef = doc(db, "userFavorites", user.uid);
      await setDoc(userFavoritesRef, {
        favorites: favorites,
        categorizedFavorites: {
          ...categorizedFavorites,
          [newCategoryName.trim()]: []
        },
        categories: updatedCategories
      }, { merge: true });
      
      setCategories(updatedCategories);
      setCategorizedFavorites({
        ...categorizedFavorites,
        [newCategoryName.trim()]: []
      });
      
      setNewCategoryName("");
      toast.success("Categoria adicionada com sucesso!");
    } catch (error) {
      console.error("Erro ao adicionar categoria:", error);
      toast.error("Erro ao adicionar categoria.");
    }
  };

  // Função para editar uma categoria existente
  const updateCategory = async () => {
    if (!newCategoryName.trim() || !editingCategory) {
      toast.error("O nome da categoria não pode estar vazio.");
      return;
    }

    if (categories.includes(newCategoryName.trim()) && newCategoryName.trim() !== editingCategory) {
      toast.error("Esta categoria já existe.");
      return;
    }

    const updatedCategories = categories.map(cat => 
      cat === editingCategory ? newCategoryName.trim() : cat
    );

    // Atualizar as imagens categorizadas
    const updatedCategorizedFavorites = { ...categorizedFavorites };
    updatedCategorizedFavorites[newCategoryName.trim()] = updatedCategorizedFavorites[editingCategory] || [];
    delete updatedCategorizedFavorites[editingCategory];

    try {
      const userFavoritesRef = doc(db, "userFavorites", user.uid);
      await setDoc(userFavoritesRef, {
        favorites: favorites,
        categorizedFavorites: updatedCategorizedFavorites,
        categories: updatedCategories
      });
      
      setCategories(updatedCategories);
      setCategorizedFavorites(updatedCategorizedFavorites);
      
      setNewCategoryName("");
      setEditingCategory(null);
      toast.success("Categoria atualizada com sucesso!");
    } catch (error) {
      console.error("Erro ao atualizar categoria:", error);
      toast.error("Erro ao atualizar categoria.");
    }
  };

  // Função para excluir uma categoria
  const deleteCategory = async (categoryToDelete) => {
    if (categoryToDelete === "Outros") {
      toast.error("A categoria 'Outros' não pode ser excluída.");
      return;
    }

    // Mover imagens para a categoria "Outros"
    const updatedCategorizedFavorites = { ...categorizedFavorites };
    const imagesToMove = updatedCategorizedFavorites[categoryToDelete] || [];
    updatedCategorizedFavorites["Outros"] = [
      ...(updatedCategorizedFavorites["Outros"] || []),
      ...imagesToMove
    ];
    delete updatedCategorizedFavorites[categoryToDelete];

    const updatedCategories = categories.filter(cat => cat !== categoryToDelete);

    try {
      const userFavoritesRef = doc(db, "userFavorites", user.uid);
      await setDoc(userFavoritesRef, {
        favorites: favorites,
        categorizedFavorites: updatedCategorizedFavorites,
        categories: updatedCategories
      });
      
      setCategories(updatedCategories);
      setCategorizedFavorites(updatedCategorizedFavorites);
      
      if (selectedCategory === categoryToDelete) {
        setSelectedCategory("todas");
      }
      
      toast.success("Categoria excluída com sucesso!");
    } catch (error) {
      console.error("Erro ao excluir categoria:", error);
      toast.error("Erro ao excluir categoria.");
    }
  };

  // Função para atribuir uma categoria a uma imagem
  const assignCategory = async (image, category) => {
    if (!user) {
      toast.warn("Você precisa estar logado para atribuir categorias.", {
        position: "top-right",
        autoClose: 1500,
        onClose: () => handleLogin(),
      });
      return;
    }

    // Primeiro, remover a imagem de qualquer categoria atual
    const updatedCategorizedFavorites = { ...categorizedFavorites };
    
    for (const [cat, images] of Object.entries(updatedCategorizedFavorites)) {
      updatedCategorizedFavorites[cat] = images.filter(img => img !== image);
    }
    
    // Adicionar a imagem à nova categoria
    if (!updatedCategorizedFavorites[category]) {
      updatedCategorizedFavorites[category] = [];
    }
    updatedCategorizedFavorites[category].push(image);
    
    try {
      const userFavoritesRef = doc(db, "userFavorites", user.uid);
      await setDoc(userFavoritesRef, {
        favorites: favorites,
        categorizedFavorites: updatedCategorizedFavorites,
        categories: categories
      });
      
      setCategorizedFavorites(updatedCategorizedFavorites);
      setShowAssignCategoryModal(false);
      setImageToAssignCategory(null);
      
      toast.success(`Imagem movida para a categoria "${category}"`);
    } catch (error) {
      console.error("Erro ao atribuir categoria:", error);
      toast.error("Erro ao atribuir categoria à imagem.");
    }
  };

  // Modificamos esta função para receber a imagem diretamente em vez do índice
  const openModal = (image) => {
    setSelectedImage(image);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  // Abrir modal para atribuir categoria
  const openAssignCategoryModal = (image) => {
    setImageToAssignCategory(image);
    setShowAssignCategoryModal(true);
  };

  const toggleFavorite = async (image) => {
    if (!user) {
      toast.warn("Você precisa estar logado para favoritar.", {
        position: "top-right",
        autoClose: 1500,
        onClose: () => handleLogin(),
      });
      return;
    }

    const userFavoritesRef = doc(db, "userFavorites", user.uid);
    const userFavoritesSnap = await getDoc(userFavoritesRef);

    let newFavorites = [];
    let newCategorizedFavorites = { ...categorizedFavorites };

    if (userFavoritesSnap.exists()) {
      newFavorites = userFavoritesSnap.data().favorites || [];
      newCategorizedFavorites = userFavoritesSnap.data().categorizedFavorites || { "Outros": [] };
    }

    if (newFavorites.includes(image)) {
      // Remover dos favoritos
      newFavorites = newFavorites.filter((fav) => fav !== image);
      
      // Remover de todas as categorias
      for (const category in newCategorizedFavorites) {
        newCategorizedFavorites[category] = newCategorizedFavorites[category].filter(
          img => img !== image
        );
      }
    } else {
      // Adicionar aos favoritos
      newFavorites = [...newFavorites, image];
      
      // Adicionar à categoria "Outros" por padrão
      if (!newCategorizedFavorites["Outros"]) {
        newCategorizedFavorites["Outros"] = [];
      }
      newCategorizedFavorites["Outros"].push(image);
    }

    try {
      await setDoc(userFavoritesRef, { 
        favorites: newFavorites,
        categorizedFavorites: newCategorizedFavorites,
        categories: categories
      });
      setFavorites(newFavorites);
      setCategorizedFavorites(newCategorizedFavorites);
    } catch (error) {
      console.error("Erro ao salvar favoritos:", error);
    }
  };

  return (
    <div className="container">
      <div className="container-title">
        <span style={{ fontFamily: 'Great Vibes, cursive', fontSize: '30px', color: "#74dcff" }}>
          Galeria &nbsp;
        </span>
        <span style={{ fontFamily: 'Dancing Script, cursive', fontSize: '30px', color: "#74dcff" }}>
          STL 3D
        </span>
        {user ? (
          <button className="button-login" onClick={handleLogout}>Sair</button>
        ) : (
          <button className="button-login" onClick={handleLogin}>Login</button>
        )}
        <ToastContainer />
      </div>
      <div className="container-header">
        <input
          type="text"
          placeholder="Qual personagem você procura?"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
        <select onChange={(e) => handleFilterChange(e.target.value)} className="filter-select">
          <option value="todos">Todos</option>
          <option value="favoritos">Favoritos</option>
        </select>
        
        {/* Exibir seletor de categorias apenas quando estiver na visualização de favoritos */}
        {filterOption === "favoritos" && (
          <div className="category-controls">
            <select 
              onChange={(e) => handleCategoryChange(e.target.value)} 
              value={selectedCategory} 
              className="category-select"
            >
              <option value="todas">Todas as Categorias</option>
              {categories.map((category) => (
                <option key={category} value={category}>
                  {category}
                </option>
              ))}
            </select>
            
            <button 
              className="category-manage-button"
              onClick={() => setShowCategoryModal(true)}
              title="Gerenciar Categorias"
            >
              <FaFolderPlus />
            </button>
          </div>
        )}
      </div>

      {filterOption === "todos" && !searchTerm && (
        <AlphabetNavigation
          onLetterClick={scrollToLetter}
          activeLetters={activeLetters}
        />
      )}

      {/* Condição especial para renderizar favoritos agrupados por categoria */}
      {filterOption === "favoritos" && selectedCategory === "todas" ? (
        renderFilteredImages()  // Aqui renderFilteredImages retornará diretamente o JSX sem a div "grid"
      ) : (
        <div className="grid">
          {filterOption === "todos"
            ? renderImagesByLetter()
            : renderFilteredImages()}
        </div>
      )}

      {/* Modal de imagem ampliada - modificado para incluir opção de categoria */}
      {selectedImage !== null && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button onClick={() => toggleFavorite(selectedImage)} className="favorite-button_modal">
              <FaHeart color={favorites.includes(selectedImage) ? "red" : "gray"} />
            </button>

            {favorites.includes(selectedImage) && (
              <button 
                onClick={() => openAssignCategoryModal(selectedImage)} 
                className="category-button_modal"
                title="Atribuir Categoria"
              >
                <FaFolderPlus />
              </button>
            )}

            <button onClick={closeModal} className="close-button">X</button>

            <div className="div-image">
              <img
                src={`/imagens-op/${selectedImage}`}
                alt="Imagem ampliada"
                className="modal-image"
              />
            </div>

            {/* Adicionando o nome da imagem aqui */}
            <p className="modal-image-name">
              {formatImageName(selectedImage, false)}
            </p>
            
            {/* Exibir categoria se for um favorito */}
            {favorites.includes(selectedImage) && (
              <p className="modal-image-category">
                Categoria: {getImageCategory(selectedImage)}
              </p>
            )}
          </div>
        </div>
      )}

      {/* Modal para gerenciar categorias */}
      {showCategoryModal && (
        <div className="modal-overlay" onClick={() => setShowCategoryModal(false)}>
          <div className="modal-content category-modal" onClick={(e) => e.stopPropagation()}>
            <h3>Gerenciar Categorias</h3>
            
            <div className="category-form">
              <input
                type="text"
                placeholder="Nome da categoria"
                value={newCategoryName}
                onChange={(e) => setNewCategoryName(e.target.value)}
              />
              
              {editingCategory ? (
                <div className="category-buttons">
                  <button onClick={updateCategory}>Atualizar</button>
                  <button onClick={() => {
                    setEditingCategory(null);
                    setNewCategoryName("");
                  }}>Cancelar</button>
                </div>
              ) : (
                <button onClick={addCategory}>Adicionar Categoria</button>
              )}
            </div>
            
            <div className="category-list">
              <h4>Categorias Existentes</h4>
              <ul>
                {categories.map((category) => (
                  <li key={category}>
                    <span>{category}</span>
                    <div className="category-actions">
                      <button 
                        onClick={() => {
                          setEditingCategory(category);
                          setNewCategoryName(category);
                        }}
                        disabled={category === "Outros"}
                      >
                        <FaEdit />
                      </button>
                      <button 
                        onClick={() => deleteCategory(category)}
                        disabled={category === "Outros"}
                      >
                        <FaTrash />
                      </button>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            
            <button onClick={() => setShowCategoryModal(false)} className="close-button">X</button>
          </div>
        </div>
      )}

      {/* Modal para atribuir categoria a uma imagem */}
      {showAssignCategoryModal && imageToAssignCategory && (
        <div className="modal-overlay" onClick={() => setShowAssignCategoryModal(false)}>
          <div className="modal-content assign-category-modal" onClick={(e) => e.stopPropagation()}>
            <h3>Atribuir Categoria</h3>
            
            <div className="image-preview">
              <img 
                src={`/imagens-op/${imageToAssignCategory}`} 
                alt="Imagem para categorizar" 
              />
              <p>{formatImageName(imageToAssignCategory, false)}</p>
            </div>
            
            <div className="category-selection">
              <p>Selecione uma categoria:</p>
              <ul>
                {categories.map((category) => (
                  <li key={category}>
                    <button 
                      onClick={() => assignCategory(imageToAssignCategory, category)}
                      className={getImageCategory(imageToAssignCategory) === category ? "active" : ""}
                    >
                      {category}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            
            <button onClick={() => setShowAssignCategoryModal(false)} className="close-button">X</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default App;